export { default as QuickBookingRest } from './QuickBookingRest'
